import { getEditableFloat, getEditableInteger, getFloat, getFormattedDate, getFormattedDateTime, getFormattedDuration, getFormattedFloat, getFormattedInteger, getFormattedPrice, getFormattedTime, getHumanReadableDuration, } from "@msys/formatting";
import React from "react";
import { useLocale } from "../LocaleProvider.js";
export function useFormatting() {
    const locale = useLocale();
    const memoizedGetFormattedPrice = React.useCallback((value) => getFormattedPrice(value, locale), [locale]);
    const memoizedGetFormattedFloat = React.useCallback((value, step) => getFormattedFloat(value, locale, step), [locale]);
    const memoizedGetEditableFloat = React.useCallback((value, returnEmptyStringIfZero, step) => getEditableFloat(value, locale, returnEmptyStringIfZero, step), [locale]);
    const memoizedGetFloat = React.useCallback((value, returnZeroIfNaN) => getFloat(value, locale, returnZeroIfNaN), [locale]);
    const memoizedGetFormattedDate = React.useCallback((value) => getFormattedDate(value, locale), [locale]);
    const memoizedGetFormattedDateTime = React.useCallback((value) => getFormattedDateTime(value, locale), [locale]);
    return {
        getFormattedInteger,
        getEditableInteger,
        getFormattedTime,
        getFormattedDuration,
        getFormattedDate: memoizedGetFormattedDate,
        getFormattedDateTime: memoizedGetFormattedDateTime,
        getFloat: memoizedGetFloat,
        getFormattedFloat: memoizedGetFormattedFloat,
        getFormattedPrice: memoizedGetFormattedPrice,
        getEditableFloat: memoizedGetEditableFloat,
        getHumanReadableDuration: getHumanReadableDuration,
    };
}
//# sourceMappingURL=useFormatting.js.map